import { RouteRecordRaw } from 'vue-router'

const keyContactsRoutes: RouteRecordRaw[] = [
  {
    path: '/key-contacts',
    name: 'key-contacts.index',
    component: () => import('@/modules/key-contacts/views/KeyContactIndex.vue'),
    meta: {
      pageTitle: 'Key contacts',
      breadcrumbs: ['Key contacts']
    }
  }
]

export default keyContactsRoutes
